export default [
	{
        path: '/about-us',
        name: 'about-us',
        component: () => import ('../components/AboutUs.vue'),
        meta: {
        }
    },
]
